module.exports = __webpack_public_path__ + "img/pistonheads-logo.661a3aa9.svg";